import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-pre-authorie",
  templateUrl: "./pre-authorie.component.html",
})
export class PreAuthorieComponent implements OnInit {
  path: any;
  scheduleappointmentid: any = "";
  appointData: any = {};
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
    }
    sessionStorage.getItem("appointData") !== null
      ? (this.appointData = JSON.parse(sessionStorage.getItem("appointData")))
      : (this.appointData = {});
    if (!this.appointData) {
      this.router.navigate(["/home"]);
    }
  }

  scheduleappointment(type) {
    const data = this.appointData;
    if (type === "yes") {
      data.preAuthorized = true;
    } else {
      data.preAuthorized = false;
    }
    data["patientType"] = "Sched";
    this.appservice.scheduleappointment(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          sessionStorage.setItem("appointData", null);
          if (type === "yes") {
            this.router.navigate(["/patient-profile", res["entity"].id]);
          } else {
            this.router.navigate(["/pre-autho2", res["entity"].id]);
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }
}
